import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose Us For Software Development in Los Angeles?</h2>
            <p>
              We are one of the few software development companies in Los
              Angeles that have successfully scaled up and shown continuous
              exponential growth over time. With a solid track record, we have
              consistently delivered top-tier mobile apps, earning industry
              acclaim and achieving success. Being based in Los Angeles, we
              possess an in-depth understanding of the local market and its
              distinct dynamics, giving your software solution a competitive
              edge.
            </p>
            <p>
              Our team of professional software developers in Los Angeles excels
              in crafting personalized mobile apps customized to your specific
              business needs and goals, ensuring a perfect match. Moreover,
              client satisfaction remains our utmost priority, and we go the
              extra mile to surpass your expectations.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <StaticImage
              src="../../images/location_new/fold7/los-angeles-1.webp"
              alt="los-angeles"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={525}
              height={804}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
